/** 取第一个有效秒级时间戳（忽略 null/空串/0；兼容 Portal 将 etd 序列化为 ""） */
export function resolveTransportTimestamp(...candidates) {
  const minTs =
    candidates.length > 0 &&
    candidates[candidates.length - 1] != null &&
    typeof candidates[candidates.length - 1] === 'object' &&
    !Array.isArray(candidates[candidates.length - 1]) &&
    Object.prototype.hasOwnProperty.call(candidates[candidates.length - 1], 'minTs')
      ? candidates.pop().minTs
      : undefined

  for (const raw of candidates) {
    if (raw === undefined || raw === null || raw === '') continue
    const n = typeof raw === 'string' ? parseInt(raw, 10) : raw
    if (!Number.isFinite(n) || n <= 0) continue
    if (minTs != null && n < minTs) continue
    return n
  }
  return undefined
}

/** 到港/落地不得早于开船/起飞 */
export function normalizeTransportTimes(etd, eta) {
  if (etd != null && eta != null && eta < etd) {
    return { etd, eta: undefined }
  }
  return { etd, eta }
}

/** 物流日志兜底：柜子/订单无 etd/eta 时，从开船/到港节点取 createTime */
export function extractLogisticsEtdEta(logs) {
  if (!logs || !logs.length) return {}
  let etd
  let eta
  for (const log of logs) {
    const t = log.createTime
    if (!t || t <= 0) continue
    const status = String(log.status ?? '')
    const content = log.content ?? ''
    if (status === '7' || /开船|起飞|Departure/i.test(content)) {
      if (!etd || t > etd) etd = t
    }
    if (status === '8' || /到港|落地|arrived/i.test(content)) {
      if (!eta || t > eta) eta = t
    }
  }
  if (etd != null && eta != null && eta < etd) {
    eta = undefined
    for (const log of logs) {
      const t = log.createTime
      if (!t || t < etd) continue
      const status = String(log.status ?? '')
      const content = log.content ?? ''
      if (status === '8' || /到港|落地|arrived/i.test(content)) {
        if (!eta || t > eta) eta = t
      }
    }
  }
  return normalizeTransportTimes(etd, eta)
}

/** 柜子 → 订单 → 物流日志，解析 ETD/ETA */
export function resolveOrderTransportTimes({ container, order, logistics }) {
  const logisticsTimes = extractLogisticsEtdEta(logistics)
  const etd = resolveTransportTimestamp(
    container && container.etd,
    order && order.etd,
    logisticsTimes.etd
  )
  const eta = resolveTransportTimestamp(
    container && container.eta,
    order && order.eta,
    logisticsTimes.eta,
    { minTs: etd }
  )
  return normalizeTransportTimes(etd, eta)
}

/** 按渠道 transport_mode_code 返回 ETD/ETA 标签 */
export function mapTransportTimeLabels(transportModeCode) {
  const code = String(transportModeCode ?? '')
  if (code === '01') {
    return { etdLabel: '开船日', etaLabel: '到港日' }
  }
  if (code === '02') {
    return { etdLabel: '起飞日', etaLabel: '落地日' }
  }
  return { etdLabel: '出发日', etaLabel: '到达日' }
}
